export const getTotalPages = (totalCount, pageSize) => {
  if (!pageSize || pageSize <= 0) {
    return 1;
  }
  return Math.max(1, Math.ceil(totalCount / pageSize));
};

export const getOffsetPaginationMeta = ({
  itemCount = 0,
  page = 1,
  pageSize = 10,
}) => {
  const safePageSize = Math.max(1, pageSize);
  const safePage = Math.max(1, page);
  const hasNextPage = itemCount === safePageSize;
  const hasPreviousPage = safePage > 1;
  const totalPages = hasNextPage ? safePage + 1 : Math.max(safePage, 1);

  return {
    page: safePage,
    pageSize: safePageSize,
    totalPages,
    hasNextPage,
    hasPreviousPage,
    offset: (safePage - 1) * safePageSize,
  };
};

export const paginateItems = (items = [], page = 1, pageSize = 10) => {
  const safePage = Math.max(1, page);
  const safePageSize = Math.max(1, pageSize);
  const totalItems = items.length;
  const totalPages = getTotalPages(totalItems, safePageSize);
  const currentPage = Math.min(safePage, totalPages);
  const startIndex = (currentPage - 1) * safePageSize;
  const endIndex = Math.min(startIndex + safePageSize, totalItems);

  return {
    items: items.slice(startIndex, endIndex),
    page: currentPage,
    pageSize: safePageSize,
    totalItems,
    totalPages,
    startIndex,
    endIndex,
    hasNextPage: currentPage < totalPages,
    hasPreviousPage: currentPage > 1,
  };
};
